/**
 * PostHog configuration
 * Centralized configuration for PostHog initialization
 */

/**
 * PostHog initialization configuration
 * Optimized for reduced network traffic and better performance
 */
export const POSTHOG_CONFIG = {
  // Enable automatic pageview tracking. The posthog-js/react PostHogProvider
  // handles Next.js App Router route changes automatically when this is on,
  // giving us the baseline $pageview events required for funnels.
  capture_pageview: true,
  // Capture pageleave only when pageviews are captured — enables time-on-page
  // analysis without ballooning request volume for anonymous users.
  capture_pageleave: 'if_capture_pageview' as const,
  // Only create person profiles for identified users (recommended)
  person_profiles: 'identified_only' as const,
  // Disable autocapture by default (enabled only for logged-in users via identifyUser())
  // Autocapture tracks clicks, form submissions, etc. - useful for logged-in users to understand UI interactions
  // This complements our custom business events (Gmail connections, settings updates, etc.)
  autocapture: false,
  // Disable session recording by default (enabled only for logged-in users via identifyUser())
  // This reduces network traffic for anonymous users while still capturing sessions for authenticated users
  disable_session_recording: true,
  // Disable feature flags polling (not using feature flags, reduces network requests)
  advanced_disable_feature_flags: true,
  // Optimize batching to reduce network requests
  // Increase batch size from default 10 to 50 events per batch
  batch_size: 50,
  // Send batch when it reaches 50 events (matches batch_size)
  flush_at: 50,
  // Wait up to 30 seconds before flushing batch (default: 10 seconds)
  // This allows more events to accumulate before sending, reducing request frequency
  flush_interval: 30000,
} as const;
